// @ts-nocheck

import { makeWapiCall } from '../utils/api';

const UrlShort = {};

UrlShort.getShortDatas = async (shortURLId: string) => {
  return await makeWapiCall({
    namespace: 'core/shorturl',
    method: 'GetShortURLData',
    params: {
      shortURLId,
    },
  });
};

type ShortenBetshareURLParams = {
  jwt: string;
  wam?: string;
  host: string;
  path?: string;
  fragment?: string;
  data: {
    [key: string]: unknown;
  };
};

UrlShort.createShortDatas = async (params: ShortenBetshareURLParams) => {
  const { error, shortURLId } = await makeWapiCall({
    namespace: 'core/shorturl',
    method: 'ShortenBetshareURL',
    params,
  });

  if (error) {
    throw new Error();
  }

  return shortURLId;
};

export default UrlShort;
